// easyui-error.service.ts
// (c) 2017 EvoluS Srl
// (a) VG

import { Injectable } from '@angular/core';

@Injectable()
export class EasyuiErrorService {
  message(err: any): string {
    if (err.required || err.requiredValue) {
      return ('Questo non può essere vuoto');
    }
    if (err.maxlength) {
      return (`Introdurre al massimo ${err.maxlength.requiredLength} caratteri`);
    }
    if (err.minlength) {
      return (`Introdurre almeno ${err.minlength.requiredLength} caratteri`);
    }
    if (err.pattern) {
      // err.pattern.actualValue
      // err.pattern.requiredPattern
      return ('Dato introdotto non valido');
    }
    if (err.invalidCodfis) {
      return ('Codice fiscale non valido');
    }
    if (err.invalidDate) {
      return ('Data non valida');
    }
    if (err.invalidInt) {
      return ('Non è un numero intero');
    }
    if (err.invalidFloat) {
      return ('Non è un numero valido');
    }
    if (err.invalidCurrency) {
      return ('Non è un valore valido');
    }
    if (err.invalidPassword) {
      return (`Password non valida - Introdurre almeno:<br>Una lettera minuscola, una maiuscola e un numero<br>Niente spazi - Permessi anche !$%&=?,.;:@#`);
    }
    if (err.passNotEqual) {
      return (`La password introdotta non è uguale a quella ripetuta`);
    }
    if (err.passEqOld) {
      return (`La nuova password deve essere diversa da quella vecchia`);
    }
    return 'Dato introdotto non valido';
  }
}



// WEBPACK FOOTER //
// ./src/app/easyui-ts/easyui-error.service.ts